module.exports = __webpack_public_path__ + "img/loyalty-email.638c08ab.svg";